<template lang="pug">
    .z-big-multy-select(ref="parent" v-bind:class="{'focus': focus, 'no-label' : ($props.label ? false : true), 'has-value': $props.value, 'has-error': error && error.length, 'disabled': $props.disabled, 'readonly': $props.readonly}")
        .z-big-multy-select-container(v-on:click="onFocus" v-bind:class="{'active': focus}")
            .icon(v-html="$props.icon")
            .z-big-multy-select-label-container
                label.z-big-multy-select-label(v-bind:class="{'has-value': (displayLabel && displayLabel.length) ? true : false}") {{$props.label}}
                label.z-big-multy-select-display-label(v-if="displayLabel && displayLabel.length")
                    span.z-big-multy-select-display-label__item(v-for="item in displayLabel") {{item}}
            .z-big-multy-select__arrow
                i.fas.fa-chevron-down
            .z-big-multy-select__clear(v-on:click="clear")
                i.fas.fa-times
            input(
                ref="input"
                v-model="val"
                v-bind:id="$props.id"
                v-bind:name="$props.name"
                v-bind:required="$props.required"
                v-bind:disabled="$props.disabled"
                v-bind:readonly="$props.readonly"
                type="hidden"
            )
        .z-big-multy-select-input__container
            .z-big-multy-select-input.can-scroll(v-bind:class="{'active': focus}")
                slot
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-big-multy-select',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-input'
            },
            name: {
                type: String,
                default: 'z-input'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: Array,
                default: () => []
            },
            icon: {
                type: String,
                default: '<i class="fab fa-accessible-icon"></i>'
            },
        },
        data() {
            return {
                focus: false,
                val: [],
                displayLabel: [],
            }
        },
        created() {
            if (this.$props.value) {
                this.val = Object.assign([], this.$props.value);
                this.setLabel();
            }
        },
        mounted() {
            if (this.$props.value) {
                this.val = Object.assign([], this.$props.value);
                this.setLabel();
            }
        },
        watch: {
            'value'(value, old) {
                if (JSON.stringify(this.val) != JSON.stringify(value)) {
                    this.val = Object.assign([], value);
                    this.setLabel();
                }
            }
        },
        computed: {},
        methods: {
            listeners() {
                this.blurListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.onBlur();
                });
            },
            setLabel() {
                if (this.$children) {
                    this.displayLabel = [];
                    this.$children.map(item => {
                        if (this.val.indexOf(item.value) + 1) this.displayLabel.push(item.label);
                    });
                }
            },
            onFocus(e) {
                if (!e.target.getAttribute('data-isitem')) {
                    if (this.focus) this.onBlur();
                    else {
                        if (this.$props.disabled) return;
                        this.listeners();
                        this.focus = true;
                        this.$emit('focus');
                    }
                }
            },
            onBlur() {
                document.removeEventListener('click', this.blurListener, false);
                this.focus = false;
                this.$emit('blur');
            },
            select(label, value, blur = false) {
                this.displayLabel.push(label);
                if (!(this.val.indexOf(value)+1)) this.val.push(value);
                this.$emit('input', this.val);
                if (blur) this.onBlur();
            },
            unselect(label, value, blur = false) {
                let displayIndex = this.displayLabel.findIndex(item => item == label),
                    valueIndex   = this.val.findIndex(item => item == value);
                
                if (displayIndex || parseInt(displayIndex) == 0) this.displayLabel.splice(displayIndex, 1);
                if (valueIndex   || parseInt(valueIndex) == 0)   this.val.splice(valueIndex, 1);

                this.$emit('input', this.val);
                if (blur) this.onBlur();
            },
            clear(e) {
                if (e) e.stopPropagation();
                this.displayLabel = [];
                this.val = [];
                this.$emit('input', this.val);
            }
        }
    }
</script>
<style lang="sass">
    .z-big-multy-select
        margin: 4px 0 10px 0
        position: relative
        &.disabled
            .z-big-multy-select-container
                background: #eee
                .z-big-multy-select-label
                    width: calc(100% - 35px)
            .z-big-multy-select__arrow
                display: none
            .z-big-multy-select__clear
                display: none
        .z-big-multy-select-container
            display: flex
            align-items: center
            justify-content: flex-start
            min-height: 50px
            background: #FFFFFF
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2)
            border-radius: 3px
            padding: 10px
            .z-big-multy-select-label-container
                display: flex
                flex-direction: column
                width: calc(100% - 90px)
                font-size: 14px
                line-height: 14px
                align-items: flex-start
                justify-content: center
                .z-big-multy-select-display-label, .z-big-multy-select-label
                    width: 100%
                .z-big-multy-select-label.has-value
                    color: #7b7b7b
                    margin: 0 0 4px 0
                    font-size: 12px
                    line-height: 12px
                .z-big-multy-select-display-label
                    display: flex
                    flex-wrap: wrap
                    align-items: flex-start
                    justify-content: flex-start
                .z-big-multy-select-display-label__item
                    max-width: calc(50% - 4px)
                    margin: 0 2px 2px 2px
                    white-space: nowrap
                    overflow: hidden
                    text-overflow: ellipsis
                    border-radius: 3px
                    padding: 4px 4px 2px 4px
                    background: #efefef
            .icon
                font-size: 22px
                width: 24px
                height: 22px
                color: #000
                margin: 0 10px 0 0
                svg
                    width: 24px
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding-top: 4px
            color: #ff1744
        label
        select
            font-size: 14px
            line-height: 24px
            border: none
            background: #fff
            outline: none
            color: #000
            font-weight: 400
            height: 26px
            width: 100%
            position: relative
            z-index: 10
            -webkit-appearance: none !important
        .error
        .z-big-multy-select-input__container
            position: relative
            .z-big-multy-select-input
                display: none
                position: absolute
                padding: 10px 0
                width: 100%
                left: 0
                right: 0
                top: -5px
                z-index: 101
                background: #FFFFFF
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)
                border-radius: 3px
                border-top-left-radius: 0
                border-top-right-radius: 0
                max-height: 250px
                overflow-y: auto
                &.active
                    display: block
        .z-big-multy-select__arrow, .z-big-multy-select__clear
            position: absolute
            z-index: 1
            right: 10px
            font-size: 16px
            width: 25px
            height: 25px
            border-radius: 100%
            display: flex
            align-items: center
            justify-content: center
        .z-big-multy-select__clear
            right: 35px
            cursor: pointer
            &:hover
                background: #e4e4e4
            &:active
                background: #d3d3d3
                
    .z-big-multy-select.has-error
        label   
            color: #ff1744
        .z-big-multy-select-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-big-multy-select.focus
        label
        .z-big-multy-select-container
            &::after
                
            &::before
                
    .z-big-multy-select.disabled
        select
            background: #eaeaea
    .z-big-multy-select.readonly
        select
            background: #eaeaea                
</style>


// WEBPACK FOOTER //
// ZBigMultySelect.vue?0eb2bf9a